window.addEventListener('DOMContentLoaded',function(){
  const popovers = [...document.querySelectorAll('[data-bs-toggle="popover"]')]
    .map(el => new bootstrap.Popover(el))

  document.addEventListener('click', (e) => {
    const onToggle = e.target.closest('[data-bs-toggle="popover"]')
    const insidePopover = e.target.closest('.popover')
    if (!onToggle && !insidePopover) {
      popovers.forEach(p => p.hide())
    }
  });
});
